import { StatusTransferList } from "~/pages/administration/lists/lists-dialog/status/status-transfer-list";
import type { ListStatuses } from "~/types/api";
import type { StatusContainerId } from "./dnd";

type Props = {
  setSelectedAvailableItems: React.Dispatch<React.SetStateAction<number[]>>;
  setSelectedSelectedItems: React.Dispatch<React.SetStateAction<number[]>>;
  setSelectedCodes: React.Dispatch<React.SetStateAction<number[]>>;
  selectedAvailableItems: number[];
  selectedSelectedItems: number[];
  availableStatuses: ListStatuses[];
  chosenStatuses: ListStatuses[];
  formData: { workflowId: number | null };
  statusesLoading: boolean;
  hasStatuses: boolean;
  reorderChosenStatuses: (reordered: ListStatuses[]) => void;
};

const EmptyState = ({ message }: { message: string }) => (
  <div className="py-8 text-center text-gray-500">{message}</div>
);

const StatusSectionWrapper = ({ children }: { children: React.ReactNode }) => (
  <div className="space-y-4">
    <h3 className="text-lg font-semibold">Select for List</h3>
    {children}
  </div>
);

export const StatusSection = ({
  setSelectedAvailableItems,
  setSelectedSelectedItems,
  setSelectedCodes,
  selectedAvailableItems,
  selectedSelectedItems,
  availableStatuses,
  chosenStatuses,
  formData,
  statusesLoading,
  hasStatuses,
  reorderChosenStatuses,
}: Props) => {
  const handleMove = (codes: number[], to: StatusContainerId) =>
    setSelectedCodes((prev) =>
      to === "selected"
        ? [...prev, ...codes.filter((c) => !prev.includes(c))]
        : prev.filter((c) => !codes.includes(c))
    );

  if (!formData.workflowId) {
    return (
      <StatusSectionWrapper>
        <EmptyState message="Please select a workflow to configure statuses for this list." />
      </StatusSectionWrapper>
    );
  }

  if (statusesLoading) {
    return (
      <StatusSectionWrapper>
        <EmptyState message="Loading statuses..." />
      </StatusSectionWrapper>
    );
  }

  if (!hasStatuses) {
    return (
      <StatusSectionWrapper>
        <EmptyState message="No statuses available for this workflow" />
      </StatusSectionWrapper>
    );
  }

  return (
    <StatusSectionWrapper>
      <StatusTransferList
        availableStatuses={availableStatuses}
        chosenStatuses={chosenStatuses}
        selectedAvailableItems={selectedAvailableItems}
        selectedChosenItems={selectedSelectedItems}
        setSelectedAvailableItems={setSelectedAvailableItems}
        setSelectedChosenItems={setSelectedSelectedItems}
        onMove={handleMove}
        onReorder={reorderChosenStatuses}
        availableTitle="Item Status"
        chosenTitle="Selected Item Status"
        availableEmptyPlaceholder="All statuses selected"
        chosenEmptyPlaceholder="No statuses selected"
      />
    </StatusSectionWrapper>
  );
};
